<!-- 文件上传 -->
<template>
  <md-field :class="{'md-error' : error}">
    <div @click="modal_file_input" :style="{'width':'100%'}">
      <slot />
    </div>
    <md-icon v-if="error">clear</md-icon>
    <input :style="{display:'none'}" type="file" ref="inputFile" @change="otherFile" />
  </md-field>
</template>
<script>
export default {
  props:{
    error: {
      type: Boolean,
      default: false,
    },
  },
  data(){
    return {
      // childValue: this.value,
    }
  },
  methods:{
    modal_file_input(){ // 点击上传文件
      this.$refs.inputFile.click();
    },
    otherFile ($event) { // (file发生变化)
      this.onFileSelected($event)
    },
    onFileSelected ({ target, dataTransfer }) { // 选择文件
      const files = target.files || dataTransfer.files;
      this.getFileName(files, target);
    },
    getFileName (files, target) { // 获取文件名
      if (!files || files.length === 0) {
        return target.value.split('\\').pop()
      }

      if (files.length > 1) {
        return this.getMultipleName(files)
      }

      if (files.length === 1) {
        this.$emit("change","",files[0].name);
        this.$api.uploadFile_PUT({
          file: files[0], 
        })
          .then(this.$Then(res => {
            this.$emit("change",res.data.get_url, files[0].name);
          }))
          .catch(this.$Catch(this.$I18n("file_error"), () => {
            this.$emit("change","", files[0].name);
          }))
        return files[0].name
      }

      return null
    },
  },
}
</script>